import { Pipe, PipeTransform } from '@angular/core';
import { Profile } from '../models/profile';
import { PROFILE_TYPE } from '../constants';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'fullProfile'
})
export class FullProfilePipe implements PipeTransform {

  constructor(
    private translateService: TranslateService) { }

  transform(value: Profile, args?: any): any {
    return getFullProfileIdentity(value, this.translateService)
  }

}

export const getFullProfileIdentity = (profile: Profile, translateService: TranslateService): string => {
  if (!profile) { return ''; }
  
  const { type = '', firstName = '', lastName = '', vatInfo = {} } = profile;
  const { companyName = '' } = vatInfo || {};

  const prefix = '';
  let name = '';

  switch (type) {
    case PROFILE_TYPE.private:
      name = `${firstName} ${lastName && lastName[0]}.`;
      break;
    case PROFILE_TYPE.professional: {
      if (companyName) {
        name = `${companyName + ' ' + '-' + ' '}${
          translateService ? translateService.instant(`PROFESSIONAL`) : ''
        }`;
      } else {
        name = `${translateService ? translateService.instant(`PROFESSIONAL`) : ''}`;
      }
      break;
    }
    case PROFILE_TYPE.company: {
      if (companyName) {
        name = `${companyName + ' ' + '-' + ' '}${
          translateService ? translateService.instant(`PROFILE_TYPE.company`) : ''
        }`;
      } else {
        name = `${translateService ? translateService.instant(`PROFILE_TYPE.company`) : ''}`;
      }
      break;
    }
    default: {
      break;
    }
  }

  return prefix + name;
};
